import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Snackbar as MUISnackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { dismissNotification } from '../../store/notification/actions';
import { RootState } from '../../store';

const Snackbar: React.FC<{}> = () => {
  const notifications = useSelector((state: RootState) => state.notifications);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);

  const onClose = useCallback((e, reason?: string) => {
    if (reason !== 'clickaway') {
      setVisible(false);
    }
  }, []);

  const removeNotification = useCallback(() => {
    dispatch(dismissNotification());
  }, [dispatch]);

  useEffect(() => {
    setVisible(notifications.length > 0);
  }, [notifications]);

  return (
    <MUISnackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open={visible}
      autoHideDuration={5000}
      onClose={onClose}
      onExited={removeNotification}
      message={notifications.length > 0 && notifications[0].message}
      action={
        <>
          <IconButton
            size='small'
            aria-label='close'
            color='inherit'
            onClick={onClose}
            data-qa-id='notification-button-close'
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        </>
      }
      data-qa-id='notification'
    />
  );
};

export default Snackbar;
